import config from "../../config"
import RequestService from "../RequestService"

const createEquipmentItem = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/equipment_items`, { equipment_item: params }, successCallback, failureCallback)
}

export default createEquipmentItem;